import React, { Fragment, useEffect } from 'react';
import ProtectedHeader from '../layout/ProtectedHeader';
import Rating from './RatingDetail';
import { useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { getProductDetails } from '../.././actions/productActions';
import { getLastURL } from '../../helper';
import { getReviewDetailsAction } from '../../actions/userActions';

const Index = () => {

    const dispatch = useDispatch();
    const location = useLocation();
    const product_id = getLastURL(location);

    useEffect(() => {

        dispatch(getProductDetails(product_id))
        dispatch(getReviewDetailsAction(product_id, null))

    }, [])

    const { details, loading  } = useSelector(state => state.productDetails);

    return (
        <Fragment>
            <ProtectedHeader />
            
            <Rating />

        </Fragment>
    )
}

export default Index
